<script lang="ts" setup>
import { ClovyrCodeLogo } from '@clovyr/bed';
import Markdown from '@clovyr/bed/components/blocks/Markdown.vue';

import { usePollenStore } from '../../stores/pollen_store';

import InstantCode from './InstantCode.vue';

defineProps<{ instantLaunchApp: string }>();

const { garden } = usePollenStore();
const app = garden.getAppByID('code-chia')!;
</script>
<template>
  <InstantCode :instant-launch-app="instantLaunchApp" hide-code-desc>
    <ImageMedia filename="catalog/chia-logo.svg" class="chia" />
    <ClovyrCodeLogo class="code-logo" />

    <h2>Welcome to the {{ app.metadata.name }}!</h2>
    <Markdown :content="app.metadata.description" />
    <Markdown :content="app.metadata.huginnSays" />
  </InstantCode>
</template>

<style lang="scss" scoped>
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/typography/type';

.instant {
  .chia {
    :deep(img) {
      width: 246px;
    }
  }
  .code-logo {
    margin-top: 10px;
    width: 246px;
  }

  p,
  div.markdown {
    @include type.text--color-grey-light;

    margin-top: 1em;
  }

  h2 {
    margin-top: 1rem;
  }
}
</style>
